import React from "react";
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function ContactForm() {
  const navigate = useNavigate();
  return (
    
    <div className="min-h-screen bg-gradient-to-b from-gray-100 via-green-100 to-green-700 flex flex-col">
       {/* back button */}
            <div className="p-6">
              <button
                className="flex items-center gap-2 text-gray-800 font-medium hover:gap-3 transition-all"
                onClick={() => navigate("/")}
              >
                <ArrowLeft size={20} />
                <span className="text-lg">Back</span>
              </button>
            </div>
      {/* Main Content */}
      <main className="flex justify-center items-center mt-8 mb-24 px-6">
        <div className="w-full max-w-md">
          {/* Header */}
          <div className="block mb-12 mt-4 ">
           

            <h3 className="text-lg font-light text-gray-800 text-center">
              We’d love to hear from you. Have a question?
              <br />
              Reach out anytime.
            </h3>
          </div>

          {/* Form Card */}
          <div className="bg-white  rounded-3xl shadow-xl pt-12 px-6">
            <form className="space-y-6">
              {/* Name */}
              <div className="">
                <label className="block text-sm font-bold text-gray-700 mb-1 ">
                  Name
                </label>
                <input
                  type="text"
                  placeholder=""
                  className="w-full  border border-gray-300 px-4 py-1 focus:outline-none focus:ring-2 focus:ring-green-600"
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  placeholder=""
                  className="w-full  border border-gray-300 px-4 py-1   focus:outline-none focus:ring-2 focus:ring-green-600"
                />
              </div>

              {/* Phone */}
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-1">
                  Phone Number
                </label>
                <input
                  type="tel"
                  placeholder=""
                  className="w-full  border border-gray-300 px-2 py-1   focus:outline-none focus:ring-2 focus:ring-green-600"
                />
              </div>

              {/* Message */}
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-1">
                  Message
                </label>
                <textarea
                  rows={4}
                  placeholder=""
                  className="w-full  border border-gray-300 px-4 py-1   resize-none focus:outline-none focus:ring-2 focus:ring-green-600"
                />
              </div>

              {/* Submit */}
              <div className="flex justify-center pt-8">
                <button
                  type="submit"
                  className="bg-black text-white px-4 py-2  rounded-full font-medium shadow-lg hover:opacity-90 transition"
                >
                  Send Message
                </button>
              </div>
            </form>
            {/* Spacer for bottom padding */}
            <div className="h-12"></div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-6 py-6 text-center justify-self-end ">
        <p className=" text-sm text-white">
          Copyright © 2025 AADA. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
